import { AuthetncationRoutingModule } from './authentcation.routing';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationComponent } from './authentication.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { SharedModule } from '../shared/shared.module';
import { PartialUpdateComponent } from './partial-update/partial-update.component';

@NgModule({
  declarations: [
    AuthenticationComponent,
    SigninComponent,
    SignupComponent,
    PartialUpdateComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AuthetncationRoutingModule
  ]
})
export class AuthenticationModule { }
